import { motion } from "framer-motion";
import { Plus, Check, Package } from "lucide-react";
import { CATEGORY_META } from "@/lib/catalog";
import { useEnquiry } from "@/components/EnquiryCart";

export default function ProductCard({ product, index = 0 }) {
  const { items, addItem } = useEnquiry();
  const meta = CATEGORY_META[product.category] || {};
  const Icon = meta.icon || Package;
  const inCart = items.some((i) => i.id === product.id);

  return (
    <motion.article
      layout
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.96 }}
      transition={{ duration: 0.4, delay: Math.min(index * 0.04, 0.35), ease: [0.22, 1, 0.36, 1] }}
      className="group bg-white rounded-2xl border border-line overflow-hidden hover:shadow-xl hover:shadow-forest/10 hover:-translate-y-1 hover:border-forest/30 transition-[box-shadow,transform,border-color] duration-300"
      data-testid={`product-card-${product.id}`}
    >
      <div className={`h-28 flex items-center justify-center ${meta.bg || "bg-cream"} relative overflow-hidden`}>
        <Icon className={`w-11 h-11 ${meta.fg || "text-forest"} transition-transform duration-500 group-hover:scale-110`} strokeWidth={1.5} />
        <span className="absolute top-3 left-3 text-[10px] font-bold uppercase tracking-[0.15em] text-ink-muted bg-white/80 backdrop-blur px-2.5 py-1 rounded-full">
          {meta.label || product.category}
        </span>
        {!product.in_stock && (
          <span className="absolute top-3 right-3 text-[10px] font-bold uppercase tracking-wider text-red-700 bg-red-100 px-2.5 py-1 rounded-full">
            Out of stock
          </span>
        )}
      </div>
      <div className="p-5">
        <h3 className="font-serif font-semibold text-lg leading-snug text-ink">{product.name}</h3>
        <p className="mt-1 text-xs text-ink-muted line-clamp-2">{product.description}</p>
        <div className="mt-4 flex items-center justify-between">
          <div>
            <p className="font-serif font-bold text-xl text-forest">₹{product.price}</p>
            <p className="text-[11px] text-ink-muted">{product.unit}</p>
          </div>
          <button
            onClick={() => addItem(product)}
            disabled={!product.in_stock}
            data-testid={`product-card-add-button-${product.id}`}
            className={`flex items-center gap-1.5 rounded-full px-4 py-2 text-xs font-bold transition-colors duration-300 ${
              inCart
                ? "bg-forest/10 text-forest"
                : "bg-forest text-bone hover:bg-forest-deep"
            } disabled:opacity-40 disabled:cursor-not-allowed`}
          >
            {inCart ? <Check className="w-3.5 h-3.5" /> : <Plus className="w-3.5 h-3.5" />}
            {inCart ? "Added" : "Add to Enquiry"}
          </button>
        </div>
      </div>
    </motion.article>
  );
}
